import { Link, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import StudentDetail from "./StudentDetail/StudentDetail";
import Upload from "./Upload/Upload";
import ClassDetails from "./ClassDetails/ClassDetails";
import "./CourseCreation.scss";
import Headings from "../../components/Headings/Headings";
import { useEffect, useState,useRef  } from "react";
import { fetchTrainingSessionById } from "../../services/training-session.service";
import { AdminRoles } from "../../utils/constants/app-constants";
import NoPermission from "../NoPermission/NoPermission";

const CourseCreation = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sessionId = parseInt(queryParams.get("id") ?? "-1");
  const [trainingSession, setTrainingSession] = useState<any>(null);
  const [hasConceptNote, setHasConceptNote] = useState(false);
  const [loading, setLoading] = useState(true);
  const [noAccess, setNoAccess] = useState(false);
  const userRole = localStorage.getItem("role") ?? "";
  const navigate = useNavigate();
  const tabsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
  const fetchSession = async () => {
    const isRestricted =
      userRole === AdminRoles.MasterTrainer &&
      (location.pathname.includes("/classDetails") ||
        location.pathname.includes("/upload"));

    if (isRestricted) {
      setNoAccess(true);
      setLoading(false);
      return;
    }

    if (sessionId === -1) {
      if (
        location.pathname.includes("/upload") ||
        location.pathname.includes("/studentDetail")
      ) {
        navigate("/create-course/classDetails");
      }
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      const result = await fetchTrainingSessionById(sessionId);
      const sessionData = result.data?.trainingSession;
      setTrainingSession(sessionData);
      const hasConceptNote = !!(sessionData?.trainingDocument || []).find(
        (document: any) => document.documentType === "CONCEPT_NOTE"
      );
      setHasConceptNote(hasConceptNote);
      if (!hasConceptNote && location.pathname.includes("/studentDetail")) {
        navigate(`/create-course/upload?id=${sessionId}`);
      }
      if (
        isApprovedStatus(sessionData) &&
        (location.pathname.includes("/classDetails") ||
          location.pathname.includes("/upload"))
      ) {
        navigate(`/create-course/studentDetail?id=${sessionId}`);
      }
    } catch (error) {
      console.error("Failed to fetch training session", error);
    } finally {
      setLoading(false);
      }
    };
    fetchSession();
  }, [sessionId, location.pathname]);

  const isTabDisabled = (tabPath: string) => {
    const isApproved = isApprovedStatus(trainingSession);
    return (
      (sessionId === -1 &&
        (tabPath.includes("/upload") || tabPath.includes("/studentDetail"))) ||
      (!hasConceptNote && tabPath.includes("/studentDetail")) ||
      (isApproved &&
        (tabPath.includes("/classDetails") || tabPath.includes("/upload")))
    );
  };

  const isApprovedStatus = (session: any) => {
    const trainingTypeCode = session?.trainingTypeCode;
    const trainingInstance = session?.trainingInstance;
    const status = session?.status;

    return (
      ["APPROVED"].includes(status) ||
      (trainingTypeCode === "BEC+BEC TOT" &&
        trainingInstance?.some(
          (instance: { status: string }) => instance.status === "APPROVED"
        ))
    );
  };

  const tabs = [
    { path: "/create-course/classDetails", label: "Class Details" },
    { path: "/create-course/upload", label: "Upload" },
    { path: "/create-course/studentDetail", label: "Student Details" },
  ];

  if (sessionId !== -1) {
    tabs.forEach((tab) => (tab.path += `?id=${sessionId}`));
  }

  
const handleArrowKeyNavigation = (e: React.KeyboardEvent<HTMLDivElement>) => {
  const focusableTabs = Array.from(
    tabsRef.current?.querySelectorAll<HTMLAnchorElement>(".tab-item:not(.disabled)") || []
  );

  const currentIndex = focusableTabs.findIndex(
    (tab) => tab === document.activeElement
  );

  if (e.key === "ArrowRight") {
    const nextIndex = (currentIndex + 1) % focusableTabs.length;
    focusableTabs[nextIndex]?.focus();
  } else if (e.key === "ArrowLeft") {
    const prevIndex = (currentIndex - 1 + focusableTabs.length) % focusableTabs.length;
    focusableTabs[prevIndex]?.focus();
  }
};


  if (loading)
    return (
      <div className="aui-loader">
        <aui-loader type="content"></aui-loader>
      </div>
    );

  if (noAccess) return <NoPermission />;

  return (
    <div className="create-course-container">
      <main className="container py-4">
        <div className="bec-title pb-2 border-bottom">
          <aui-breadcrumb
            previouspages='[
            {"title":"All Courses","url":"/course-listing"}]'
            currentpage={
              sessionId !== -1
                ? `${trainingSession?.trainingTypeCode || ""} course`
                : "New Course"
            }
          ></aui-breadcrumb>
          <Headings size="h1" className={`mt-2 bordered pb-0 mb-0`}>
            {sessionId !== -1
              ? `${trainingSession?.trainingTypeCode || ""} Course`
              : "BEC Course Request"}
          </Headings>
        </div>

          <div className="tabs flex-wrap mt-4 pb-4 courseRequestTabs" tabIndex={-1}  role="tablist" ref={tabsRef} onKeyDown={handleArrowKeyNavigation}>
            {tabs.map((tab, index) => {
              const tabDisabled = isTabDisabled(tab.path);
              let ariaLabelText = '';
              if (sessionId === -1) {
                ariaLabelText = `${tab.label} : Fill data to activate next tab.`;
              } else if (index === 1 && !hasConceptNote) {
                  ariaLabelText = `${tab.label} : Add concept note to activate next tab.`;
                } else if (hasConceptNote) {
                  ariaLabelText = `${tab.label} : Add Student details.`;
                }
              return (
                <Link
                  key={`path-${tab.path}`}
                  to={tab.path}
                  className={`${
                    tabDisabled ? "tab-item disabled" : "tab-item"
                  } ${
                    location.pathname === tab.path.split("?")[0] ? "active" : ""
                  }`}
                  role="tab"
                  aria-selected={location.pathname === tab.path.split("?")[0]}
                  aria-disabled={tabDisabled}
                  tabIndex={tabDisabled ? -1 : 0}
                  aria-label={ariaLabelText}
                >
                  {tab.label}
                </Link>
              );
            })}
          </div>

        <div className="routers" role="tabpanel">
          <Routes>
            <Route
              path="/classDetails"
              element={<ClassDetails trainingSession={trainingSession} />}
            />
            <Route
              path="/upload"
              element={<Upload trainingSession={trainingSession} />}
            />
            <Route path="/studentDetail" element={<StudentDetail trainingSession={trainingSession}/>}></Route>
          </Routes>
        </div>
      </main>
    </div>
  );
};

export default CourseCreation;
